module.exports = __webpack_public_path__ + "static/media/lovestories.a490063b.glb";


//////////////////
// WEBPACK FOOTER
// ./src/constants/lovestories.glb
// module id = 92
// module chunks = 0